import Snapshot from "./Snapshot";

export default Snapshot; 